import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/VehiclePolicyForm.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CONFIG from "../utils/config";

const currencyOptions = ["QAR"];

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Destructure `id` directly from location.state
  const { premium, mobileNumber, id } = location.state || {};

  const initialVehicleDetails = {
    registrationNumber: "",
    chassisNumber: "",
    makeModel: "",
    manufacturingYear: "",
    expiryDate: null,
    vehicleValue: null,
    vehicleCylinder:null,
    vehicleSeats:null,
  };

  const initialPolicyDetails = {
    insuredName: "",
    policyNumber: "",
    policyStartDate: null,
    policyExpiryDate: null,
    coverageType: ["Upgrade"],
    premiumAmount: "",
    currency: "QAR",
    plan: "",
    policyCovers: "",
  };

  const [vehicleDetails, setVehicleDetails] = useState(initialVehicleDetails);
  const [policyDetails, setPolicyDetails] = useState(initialPolicyDetails);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [renProposalNumber, setRenProposalNumber] = useState("");
  useEffect(() => {
    const fetchPolicyData = async () => {
      // Use the 'id' from location.state directly
      const policyId = id;
      if (!policyId) {
        toast.error("Missing policy ID. Redirecting to home.");
        navigate("/");
        return;
      }

      try {
        const response = await fetch(`${CONFIG.BASE}/insurance/getVehicleData`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: policyId }), // Use the 'id' here
        });

        if (!response.ok) {
          throw new Error("Failed to retrieve policy data");
        }

        const userPolicy = await response.json();
        setRenProposalNumber(userPolicy.renProposalNumber)

        setVehicleDetails({
          registrationNumber: userPolicy.vehicleRegistrationNumber || "",
          chassisNumber: userPolicy.chassisNumber || "",
          vehicleUsage: userPolicy.vehUsage || "",
          manufacturingYear: userPolicy.manufacturingYear || "",
          expiryDate: userPolicy.insuranceExpiryDate
            ? new Date(userPolicy.insuranceExpiryDate)
            : null,
          vehicleValue: userPolicy.vehicleValue || null,
          vehMake: userPolicy.vehMake || userPolicy.makeModel,
          vehModel: userPolicy.vehModel || userPolicy.makeModel,
          policyType: userPolicy.policyCovers,
          sumInsuredStatus: userPolicy.sumInsuredStatus,
          vehicleCylinder:userPolicy.vehCylinder,
          vehicleSeats:userPolicy.vehSeat,
        });

        setPolicyDetails({
          insuredName: userPolicy.insuredName || "",
          policyNumber: userPolicy.renPolicyNumber || "",
          policyStartDate: userPolicy.newPolicyStartDate,
          policyExpiryDate: userPolicy.newPolicyExpiryDate,
          premiumAmount: userPolicy.premiumAmount || "",
          currency: userPolicy.currency || "QAR",
          coverageType: [],
        });


        // Map quotes for Same as Current view
        setQuotes([
          {
            name: userPolicy.existingPlan || "",
            premium: userPolicy.premiumAmount || "",
            image: "/images/" + (userPolicy.existingPlan || "default") + ".png",
            coverages: userPolicy.policyCovers ? userPolicy.policyCovers.split(",") : [],
          },
        ]);
      } catch (error) {
        console.error("Error fetching policy data:", error);
        toast.error("Unable to load policy details.");
        navigate("/");
      }
    };

    fetchPolicyData();
  }, [id, navigate]); // Depend on 'id' from location.state

  const handleInputChange = (e, setState) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCoverageChange = (e) => {
    const { value } = e.target;
    setPolicyDetails((prev) => ({ ...prev, coverageType: [value] }));
  };

  const handleFormReset = () => {
    setVehicleDetails(initialVehicleDetails);
    setPolicyDetails(initialPolicyDetails);
    setQuotes([]);
    toast.info("Form reset successfully!", {
      position: "top-right",
      autoClose: 2000,
    });
    navigate("/");
  };
 const [sgsData, setSgsData] = useState(null);

   const onclickPdf = () => {
     if (!renProposalNumber) return;
   
     const formattedProposalNumber = renProposalNumber.replace(/\//g, "_");
     const pdfUrl = `${CONFIG.PDFDOWNLOAD}/download/download_policy_format/${formattedProposalNumber}`;
   
     const link = document.createElement("a");
     link.href = pdfUrl;
     link.download = `${formattedProposalNumber}.pdf`;
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (
      !policyDetails.insuredName ||
      !policyDetails.policyNumber ||
      !policyDetails.policyStartDate ||
      !policyDetails.policyExpiryDate ||
      !policyDetails.premiumAmount ||
      policyDetails.coverageType.length === 0
    ) {
      toast.error("Please fill all required fields before proceeding!", {
        position: "top-right",
        autoClose: 2000,
      });
      setLoading(false);
      return;
    }
  
    try {
      if (policyDetails.coverageType[0] === "Same as Current") {
      
        const signaturePayload = {
          amount: Number(policyDetails.premiumAmount).toFixed(2),
          firstName: policyDetails.insuredName.split(" ")[0] || "Naveen",
          lastName: policyDetails.insuredName.split(" ")[1] || "Kumar",
          email: sgsData?.email || "gopinath@insursa.com", 
          transactionId: policyDetails.policyNumber || "NA",
        };

       
  
        // Call backend signature generation
        const paymentResponse = await fetch(`${CONFIG.PAYMENT}/payment/generate-signature`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signaturePayload),
        });
  
        if (!paymentResponse.ok) throw new Error("Payment signature generation failed");
  
        const paymentData = await paymentResponse.json();
  
        if (paymentData.status !== "SUCCESS" || !paymentData.payUrl) {
          throw new Error("Invalid payment response");
        }
        toast.success(`Success`, { position: "top-right", autoClose: 3000 });
        
        window.location.href = paymentData.payUrl;
  
      } else if (policyDetails.coverageType[0] === "Upgrade") {
        // Navigate to upgrade plan page
        navigate("/plan", { state: { id } });
      }
  
    } catch (error) {
      toast.error(`Error: ${error.message}`, { position: "top-right", autoClose: 3000 });
      setLoading(false);
    }
  };
  
  const handleActivationDateChange = (e) => {
    const selectedDate = e.target.value; // YYYY-MM-DD string
    if (!selectedDate) {
      setActivationDate("");
      setExpirationDate("");
      return;
    }
  
    if (!policyDetails.policyExpiryDate) {
      toast.error("Existing policy expiry date is not loaded yet!");
      return;
    }
  
    // Convert both dates to Date objects at local midnight
    const activation = new Date(selectedDate + "T00:00:00");
    const existingExpiry = new Date(policyDetails.policyExpiryDate);
    existingExpiry.setHours(0, 0, 0, 0); // normalize time to midnight
  
    if (activation <= existingExpiry) {
      toast.error(
        "Activation date must be greater than the existing policy expiry date!"
      );
      setActivationDate(""); // reset field
      setExpirationDate("");
      return;
    }
  
    // ✅ Valid activation date
    setActivationDate(selectedDate);
  
    // Calculate expiration date 1 year from activation
    const expiry = new Date(activation);
    expiry.setDate(expiry.getDate() + 365 - 1);
    expiry.setHours(23, 59, 0, 0);
  
    const year = expiry.getFullYear();
    const month = String(expiry.getMonth() + 1).padStart(2, "0");
    const day = String(expiry.getDate()).padStart(2, "0");
    const hours = String(expiry.getHours()).padStart(2, "0");
    const minutes = String(expiry.getMinutes()).padStart(2, "0");
  
    setExpirationDate(`${year}-${month}-${day}T${hours}:${minutes}`);
  };
   const [activationDate, setActivationDate] = useState("");
    const [expirationDate, setExpirationDate] = useState("");
    const today = new Date().toISOString().split("T")[0];
  const formattedVehicleValue = new Intl.NumberFormat().format(vehicleDetails.vehicleValue);

  return (
    <>
   
      <div className="container">
             <div className="row gy-4">
               {/* Policy Terms */}
               <div className="col-md-6">
                 <div className="card shadow p-4">
                   <h4 className="text-center" style={{ color: "#1d2671" }}>
                     📜 Policy Terms
                   </h4>
                   <form>
                     <div className="mb-3">
                       <label className="form-label">Insured Name</label>
                       <input
                         type="text"
                         className="form-control"
                         value={policyDetails.insuredName}
                         readOnly
                       />
                     </div>
     
                     <div className="mb-3">
                       <label className="form-label">New Policy Number</label>
                       <input
                         type="text"
                         className="form-control"
                         value={policyDetails.policyNumber}
                         readOnly
                       />
                     </div>
     
                     <div className="d-flex gap-3 mb-3">
                       <div className="w-50">
                         <label className="form-label">Start Date</label>
                         <DatePicker
       selected={policyDetails.policyStartDate}
       className="form-control"
       dateFormat="dd MMM yyyy"   // <-- Formats as "Sep 2025"
       readOnly
     />
                       </div>
                       <div className="w-50">
                         <label className="form-label">Expiry Date</label>
                         <DatePicker
       selected={policyDetails.policyExpiryDate}
       className="form-control"
       dateFormat="dd MMM yyyy"   // <-- Formats as "Sep 2025"
       readOnly
     />
                       </div>
                     </div>
                     <div className="row mb-3">
                     <div className="col">
                       <label className="form-label">Vehicle Seats</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.vehicleSeats}
                         readOnly
                       />
                     </div>
                     <div className="col">
                       <label className="form-label">Vehicle Cylinder</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.vehicleCylinder}
                         readOnly
                       />
                     </div>
                     </div>
                     <div className="mb-3">
                       <label className="form-label">Coverage Type</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.policyType}
                         readOnly
                       />
                     </div>
                     <div className="mb-3">
                       <label className="form-label">Manufacturing Year</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.manufacturingYear}
                         readOnly
                       />
                     </div>
                   
                    
                   </form>
                 </div>
               </div>
     
               {/* Premium Details */}
               <div className="col-md-6">
                 <div className="card shadow p-4">
                   <h4 className="text-center" style={{ color: "#1d2671" }}>
                     💰Renewal Details
                   </h4>
                   <form>
                  
                     <div className="row mb-3">
                       <div className="col-md-6">
                         <label className="form-label">Reg No</label>
                         <input
                           type="text"
                           className="form-control"
                           value={vehicleDetails.registrationNumber}
                           readOnly
                         />
                       </div>
                       <div className="col-md-6">
                         <label className="form-label">Chassis Number</label>
                         <input
                           type="text"
                           className="form-control"
                           value={vehicleDetails.chassisNumber}
                           readOnly
                         />
                       </div>
                     </div>
     
                     {vehicleDetails.sumInsuredStatus === "Y" && (
                       <div className="mb-3">
                         <label className="form-label">Vehicle Value</label>
                         <input
                           type="text"
                           className="form-control"
                           value={formattedVehicleValue}
                           readOnly
                         />
                       </div>
                     )}
     
                     <div className="mb-3">
                       <label className="form-label">Usage</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.vehicleUsage}
                         readOnly
                       />
                     </div>
     
                     <div className="mb-3">
                       <label className="form-label">Make</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.vehMake}
                         readOnly
                       />
                     </div>
     
                     <div className="mb-3">
                       <label className="form-label">Model</label>
                       <input
                         type="text"
                         className="form-control"
                         value={vehicleDetails.vehModel}
                         readOnly
                       />
                     </div>
                   </form>
                 </div>
     
                 <div className="d-flex justify-content-end align-items-center gap-3 mt-4 mb-4">
                 <button 
       className="cancel-btn" 
       onClick={() => navigate('/')}
     >
       Back
     </button>

     <button 
       className="btn btn-primary" 
       onClick={() => onclickPdf()}
     >
      Download
     </button>
     
                   
                 
                 </div>
               </div>
             </div>
           </div>
    </>
  );
};

export default Success;